export default "__VITE_ASSET__NiDo3ZOO__"